export function formatToBRL(value: number | string) {
  if (value == undefined) { return }
  if (typeof value === 'string') value = parseFloat(value);
  value = Math.round(value * 100) / 100
  return value.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
}

export function formatToPercentage(value: number | string) {
  if (value == undefined) { return }
  if (typeof value === 'string') value = parseFloat(value);
  return value.toLocaleString('pt-BR', { minimumFractionDigits: 1, maximumFractionDigits: 2 });
}
